<script>
  import { writable } from 'svelte/store';
  import { fade, scale } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';

  const intro = '/public/assets/intro_final.png';
  const crowdingImg = '/public/assets/crowding-.png';
  const crossbiteImg = '/public/assets/crossbite-.png';
  const openbiteImg = '/public/assets/openbite-.png';
  const overbiteImg = '/public/assets/overbite-.png';
  const spacingImg = '/public/assets/spacing-.png';
  const underbiteImg = '/public/assets/underbite-.png';
  const affordableImg = '/public/assets/affordable.png';
  const qualityImg = '/public/assets/quality.png';
  const customizedImg = '/public/assets/customized.png';
  const fasterImg = '/public/assets/faster.png';
  const fairyImg = '/public/assets/fairy.png';
  const analysisImg = '/public/assets/analysis.png';
  const scanImg = '/public/assets/scan.png';
  const craftImg = '/public/assets/craft.png';
  const handImg = '/public/assets/process.png';
  const toothImg = '/public/assets/human.png';

  const img1 = '/public/assets/intro_final.png';
  const img2 = '/public/assets/Intro_5.png';
  const img3 = '/public/assets/Intro_6.png';
  const img4 = '/public/assets/Intro_7.png';
  const img5 = '/public/assets/Intro_8.png';

  import AppointmentForm from './appointment.svelte';

  let modalOpen = false;

  // Function to open modal
  const openModal = () => {
    modalOpen = true;
  };

  // Function to close modal
  const closeModal = () => {
    modalOpen = false;
  };

  import { onDestroy } from 'svelte';

  const images = [img1, img2, img3, img4, img5];
  let currentIndex = 0;
  let paused = false;
  let intervalId;
  $: {
    clearInterval(intervalId);
    intervalId = setInterval(() => {
      if (!paused) {
        currentIndex = (currentIndex + 1) % images.length;
      }
    }, 5000);
  }
  onDestroy(() => { if (intervalId) clearInterval(intervalId); });
  

  const tabs = [
    { id: 'intro', label: 'Introduction'},
    { id: 'features', label: 'Features' },
    { id: 'treatments', label: 'Treatments' },
    { id: 'process', label: 'Process' },
    { id: 'differences', label: 'Why Us' },
    { id: 'closing', label: 'Get Started', icon: '🚀' }
  ];

  const activeTab = writable('intro');

  const treatments = [
    { 
      name: 'Crowding', 
      desc: "When there isn't enough space in the jaw for all teeth to fit properly.", 
      img: crowdingImg 
    },
    { 
      name: 'Cross Bite', 
      desc: "When upper teeth sit inside lower teeth when mouth is closed.", 
      img: crossbiteImg 
    },
    { 
      name: 'Open Bite', 
      desc: "When upper and lower teeth don't touch when mouth is closed.", 
      img: openbiteImg 
    },
    { 
      name: 'Over Bite', 
      desc: "When upper front teeth overlap significantly over lower teeth.", 
      img: overbiteImg 
    },
    { 
      name: 'Spacing', 
      desc: "Issues arise when there is too much space between teeth.", 
      img: spacingImg 
    },
    { 
      name: 'Underbite', 
      desc: "When lower teeth sit in front of upper teeth, creating jaw protrusion.", 
      img: underbiteImg 
    }
  ];

  const differences = [
    { title: 'Affordable', desc: 'Reduction in overall treatment cost.', img: affordableImg },
    { title: 'Quality', desc: 'Accuarte and precise treatment.', img: qualityImg },
    { title: 'Customized', desc: 'Custom made as per the patient’s occlusion.', img: customizedImg },
    { title: 'Faster Results', desc: 'Reduced in treatment time.', img: fasterImg }
  ];
  const steps = [
    {
      name: 'Analysis',
      desc: 'Our skilled technicians analysing your scan.',
      img: analysisImg
    },
    {
      name: '3D Scan',
      desc: 'Advanced 3D scanning technology captures every detail',
      img: scanImg
    },
    {
      name: 'Craft',
      desc: 'Magically handcrafted Dento-Clear Aligners.',
      img: craftImg
    }
  ];

    
    
</script>

<!-- <section class="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 relative overflow-hidden"> -->
<section class="min-h-screen bg-gradient-to-r from-cyan-200 to-yellow-100 relative overflow-hidden flex items-center justify-center">

  <div class="relative z-10 py-12 px-4 md:px-8">
    <div class="max-w-7xl mx-auto">
      <!-- Floating Header -->
      <div class="text-center mb-12" transition:fade>
        <!-- <h1 class="text-6xl md:text-8xl font-black/10 text-transparent bg-clip-text bg-gradient-to-r from-green-300 via-teal-200 to-lime-200 mb-4 tracking-tight">
           Dento-Clear
        </h1> -->
        <h1 class="text-6xl md:text-8xl font-black gradient-text mb-4 tracking-tight">
          Dento-Clear
        </h1>
        <p class="text-xl text-slate-700 font-light">Revolutionary Clear Aligners with Liquid Glass Technology</p>
      </div>

      <!-- Liquid Glass Tab Navigation -->
      <nav class="flex flex-wrap justify-center rounded-2xl mb-8 sm:mb-12 gap-2 sm:gap-4 backdrop-blur-lg bg-white/10 border border-white/20 p-3 sm:p-4 shadow-lg">
        {#each tabs as tab}
          <button
            class="group relative px-4 sm:px-6 py-3 sm:py-4 font-medium transition-all duration-300
                  {$activeTab === tab.id 
                    ? 'text-slate-800 scale-105' 
                    : 'text-slate-700 hover:text-slate-600 hover:scale-105 '}"
            on:click={() => $activeTab = tab.id}>
            
            <div class="flex items-center space-x-2">
              <span class="text-lg"></span>
              <span>{tab.label}</span>
            </div>
            
            {#if $activeTab === tab.id}
              <div class="absolute inset-0 rounded-xl bg-gradient-to-r from-cyan-500/10 to-purple-500/10 animate-pulse"></div>
            {/if}
          </button>
        {/each}
      </nav>

      <!-- Tab Content with Liquid Glass Cards -->
      {#if $activeTab === 'intro'}
        <div transition:fade={{ duration: 500, easing: quintOut }} class="text-center">
          <div class="backdrop-blur-lg backdrop-blur-sm bg-white border border-white/20 rounded-3xl p-8 md:p-12 shadow-2xl">

            <h2 class="text-3xl md:text-4xl font-bold text-slate-700 mb-6">
              Experience the Future of 
              <span class="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-green-300 to-yellow-300">
                Dental Alignment
              </span>
            </h2>

            <p class="text-xl text-slate-700 mb-8 max-w-3xl mx-auto leading-relaxed">
              Our revolutionary package combines cutting-edge technology with personalized care for the perfect smile transformation.
            </p>
            
  
            <div class="relative mb-8">
              <div class="w-full max-w-[900px] h-[300px] sm:h-[400px] md:h-[500px] mx-auto bg-gradient-to-br from-white/20 to-white/5 rounded-3xl backdrop-blur-lg border border-white/20 flex items-center justify-center shadow-2xl overflow-hidden">
                {#each images as img, i}
                  <!-- svelte-ignore a11y_img_redundant_alt -->
                  <img src={img} alt="intro_image"
                    class="absolute transition-opacity duration-1000 ease-in-out max-w-full max-h-435 object-contain" 
                    style="opacity: {currentIndex === i ? 1 : 0}"/>
                {/each}
              </div>
            </div>


            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-8 text text-slate-700">
              <div class="backdrop-blur-lg bg-white/5 rounded-xl p-3 border border-white/60">🦷 Teeth Care Kit</div>
              <div class="backdrop-blur-lg bg-white/5 rounded-xl p-3 border border-white/60">💌 Healing Note</div>
              <div class="backdrop-blur-lg bg-white/5 rounded-xl p-3 border border-white/60">💼 Aligner Case</div>
              <div class="backdrop-blur-lg bg-white/5 rounded-xl p-3 border border-white/60">🔧 Removal Tool</div>
              <div class="backdrop-blur-lg bg-white/5 rounded-xl p-3 border border-white/60">📚 User Manual</div>
              <div class="backdrop-blur-lg bg-white/5 rounded-2xl p-3 border border-white/60">🟡 Chewies</div>
            </div>

            <a href="https://dentobot.indq.in/" 
               class="inline-block bg-[rgb(130, 229, 245)] text-gray-900 text-slate-500 font-bold py-4 px-8 rounded-2xl hover:scale-105 transition-transform duration-300 shadow-lg hover:shadow-cyan-500/25   border-white/60">
              Explore Dentobot →
            </a>
          </div>
        </div>

      {:else if $activeTab === 'features'}
        <div transition:fade={{ duration: 500, easing: quintOut }}>
          <h2 class="text-4xl font-bold text-slate-700 mb-8 text-center">
            Magical <span class="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-green-300 to-yellow-300"> Dento-Clear  </span> Features
          </h2>
          
         
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            <!-- Left Card -->
            <div class="backdrop-blur-lg bg-white/10 border border-white/20 rounded-3xl p-8 shadow-2xl hover:scale-105 transition-transform duration-300">
              <div class="w-100 h-70 mx-auto mb-6 bg-gradient-to-br from-cyan-400/20 to-purple-400/20 rounded-2xl backdrop-blur-lg flex items-center justify-center">
                <img src={toothImg} alt="Tooth" class="w-135 h-65 object-contain" />
              </div>
                <p class="text-lg text-slate-500 leading-relaxed">
                      Dento-Clear aligners use liquid glass technology for unmatched comfort, making your treatment feel natural from day one. 
                      Their virtually invisible design lets you smile confidently, while each aligner is crafted for a perfect, comfortable fit. 
                      Made from <span class="text-transparent bg-clip-text bg-gradient-to-r from-green-400 via-teal-300 to-lime-500 font-semibold">100% safe, BPA-free</span> 
                      materials, you can trust that your health is our top priority.
                      
                    </p>
            </div>

              <!-- Right Card -->
            <div class="backdrop-blur-lg bg-white/10 border border-white/20 rounded-3xl p-8 shadow-2xl text-center hover:scale-105 transition-transform duration-300">
                <div class="w-100 h-70 mx-auto mb-6 bg-gradient-to-br from-purple-400/20 to-pink-400/20 rounded-2xl backdrop-blur-lg flex items-center justify-center">
                  <img src={handImg} alt="Hand" class="w-135 h-65 object-contain" />
                </div>
                <p class="text-lg text-slate-500 leading-relaxed">
                  At Dentobot, we pledge to transform your smile with subtle yet powerful effectiveness. 
                  Our revolutionary <span class="text-transparent bg-clip-text bg-gradient-to-r from-green-400 via-teal-300 to-lime-400 font-semibold">Dento-Clear Aligners</span> work quietly in the background, 
                  guiding your teeth into perfect alignment without disrupting your daily life. 
                  With every step, you experience the perfect blend of innovation, comfort, and discretion, 
                  ensuring a smile that feels as natural as it looks.
                </p>
            </div>
          </div>
        </div>

      {:else if $activeTab === 'treatments'}
        <div transition:fade={{ duration: 500, easing: quintOut }}>
          <h2 class="text-4xl font-bold text-slate-700 mb-8 text-center">
            Treatable <span class="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-green-300 to-yellow-300">Alignments</span>
          </h2>
          
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">

            {#each treatments as t}
            <div class="backdrop-blur-lg bg-white/10 border border-white/50 rounded-2xl p-6 shadow-xl text-center hover:scale-105 transition-all duration-300 group">
              <div class="w-39 h-26 mx-auto mb-4 rounded-xl backdrop-blur-lg flex items-center justify-center group-hover:scale-110 transition-transform overflow-hidden">
                <img src={t.img} alt={t.name} class="w-full h-full object-contain" />
              </div>
              <h3 class="font-semibold text-cyan-400 text-lg mb-2">{t.name}</h3>
              <p class="text-slate-700 text-lg leading-relaxed">{t.desc}</p>
            </div>
            {/each}
          </div>
        </div>

      {:else if $activeTab === 'process'}
        <div transition:fade={{ duration: 500, easing: quintOut }} class="text-center">
          <h2 class="text-4xl font-bold text-slate-700 mb-8">
            Our <span class="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-green-300 to-yellow-300">Magic</span> Process
          </h2>
          
 
          <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            {#each steps as step}
              <div class="backdrop-blur-lg bg-white/10 border border-white/60 rounded-3xl p-8 shadow-xl hover:scale-105 transition-transform duration-300 text-center">
                <!-- <div class="w-24 h-24 mx-auto mb-4 bg-gradient-to-br from-cyan-400/20 to-purple-400/20 rounded-full flex items-center justify-center"> -->
                  <div class="w-24 h-24 mx-auto mb-4 bg-gradient-to-r from-cyan-300 via-green-200 to-yellow-200 rounded-full ring-4 ring-transparent ring-offset-2 ring-offset-white flex items-center justify-center">
                  <img
                    src={step.img}
                    alt={step.name}
                    class="w-24 h-24 rounded-full object-cover"
                  />
                </div>
                <p class="text-cyan-400 font-medium">{step.name}</p>
                <div class="mt-4 text-lg text-slate-700">{step.desc}</div>
              </div>
            {/each}
          </div>

          <div class="backdrop-blur-lg bg-white/20 border border-white/60 rounded-2xl p-6 mb-4">
            <p class="text-slate-700 leading-relaxed">
              Dento-Clear offers advanced editing features including dynamic treatment visualization, 
              precision movement controls, and intuitive planning software for seamless workflow.
            </p>
          </div>
          

          <div class="inline-block bg-gradient-to-r from-cyan-400 via-green-300 to-yellow-300 text-white font-semibold text-lg px-8 py-3 rounded-full shadow-md text-center">
            Plan your treatment on your terms - anytime, anywhere
          </div>


        </div>

      {:else if $activeTab === 'differences'}
        <div transition:fade={{ duration: 500, easing: quintOut }} class="text-center">
          <h2 class="text-4xl font-bold text-slate-700 mb-12">
            What makes Dento-Clear <span class="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-green-300 to-yellow-300">Different</span> from the rest?
          </h2>
          
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
    {#each differences as feature}
      <div class="backdrop-blur-lg bg-white/10 border border-white/20 rounded-2xl p-6 shadow-xl hover:scale-105 transition-all duration-300 group">
        <div class="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-cyan-400/20 to-purple-400/20 rounded-xl backdrop-blur-lg flex items-center justify-center group-hover:scale-110 transition-transform overflow-hidden">
          <img src={feature.img} alt={feature.title} class="w-full h-full object-contain" />
        </div>
        <h3 class="font-semibold text-cyan-400 mb-4">{feature.title}</h3>
        <p class="text-slate-700 text-lg">{feature.desc}</p>
      </div>
    {/each}
  </div>

        </div>

      {:else if $activeTab === 'closing'}
        <div transition:fade={{ duration: 500, easing: quintOut }} class="text-center">
          <div class="backdrop-blur-lg bg-white/10 border border-white/20 rounded-3xl p-12 shadow-2xl">
            <h2 class="text-5xl font-bold text-slate-700 mb-6">
              Hello There! Say 
              <span class="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-green-300 to-yellow-300">'Eee'</span>
            </h2>
            <p class="text-xl text-slate-700 mb-8 max-w-3xl mx-auto leading-relaxed">
              Let's transform those pearly whites and perfect your smile with our revolutionary Dento-Clear Aligners.
            </p>
            
            <!-- Magical Tooth Fairy -->
              <div class="w-65 h-65 mx-auto mb-8 bg-gradient-to-br from-purple-400/20 to-pink-400/20 rounded-full backdrop-blur-lg border border-white/60 flex items-center justify-center shadow-2xl overflow-hidden">
                <img src={fairyImg} alt="Tooth Fairy" class="w-full h-full object-contain" />
              </div>
            <p class="text-slate-700 mb-1 max-w-3xl mx-auto leading-relaxed">
              Meet our magical tooth fairy - your whimsical guardian crafted especially for you. 
              As your dental companion, I swiftly heal all dental troubles, leaving you with a sparkling, confident smile.
            </p>
            </div>
          <br>
          <br>
<button class="group bg-gradient-to-r from-cyan-300 via-green-200 to-yellow-200 text-white font-bold py-4 px-8 hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-cyan-500/25 relative overflow-hidden mt-8" style="border-radius: 2rem;" on:click={openModal}>
  <span class="relative z-10 flex items-center space-x-2">
    <span>Start Your Journey</span>
    <span class="group-hover:translate-x-1 transition-transform"></span>
  </span>
  <div class="absolute inset-0 bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" style="border-radius: 2rem;"></div>
</button>
            <AppointmentForm isOpen={modalOpen} closeModal={closeModal} />
          </div>
      {/if}
    </div>
  </div>
</section>